$(document).ready(function () {
    if ($('#page').attr('data-page-id') === 'event') {
        // CKEDITOR.replace('event_notice');
        // CKEDITOR.replace('event_participation_modalities');
        // CKEDITOR.replace('event_email_text');
        // CKEDITOR.replace('event_email_signature');

        let orgTable = $('#orgs');
        let dateTableOrg = orgTable.DataTable({
            ajax: '/get-event-orgs/' + $('#id').val(),
            dataSrc: 'data',
            // processing: true,
            serverSide: true,
            responsive: true,
            lengthMenu: [[25, 50, -1], [25, 50, "All"]],
            columns: [
                { data: 'id', name: 'id', responsivePriority: 1 },
                { data: 'org_name', name: 'org_name' },
                { data: 'action', name: 'action', searchable: false, sortable: false, responsivePriority: 1 }
            ]
        });

        orgTable.on('click', 'tbody tr', function (v) {
            v.preventDefault();
            let data = dateTableOrg.row(this).data();
            if (data) {
                if ($(v.target).hasClass('attached') === true) {
                    data = {
                        'event_id' : $('#id').val(),
                        'org_id' : data.id,
                        'current': 'attached'
                    }
                } else if ($(v.target).hasClass('detached') === true) {
                    data = {
                        'event_id' : $('#id').val(),
                        'org_id' : data.id,
                        'current': 'detached'
                    }
                }

                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                });

                $.ajax({
                    url:'/org-attach-event',
                    type:'POST',
                    data: data,
                    success: function(response) {
                        if (response.result === true) {
                            $('body').notification({
                                type: 'info',
                                title: 'Erfolgreich',
                                message: data.current === 'detached' ?
                                    'Das Unternehmen wurde erfolgreich dem Matching Day hinzugefügt' :
                                    'Das Unternehmen wurde erfolgreich dem Matching Day entfernt'
                                ,
                                autoClose: 4000
                            });
                            dateTableOrg.draw(false);
                        } else {
                            $('body').notification({
                                type: 'error',
                                title: 'Upload',
                                message: response.error,
                                autoClose: 4000
                            });
                        }
                    },
                });
            }
        });

        // $('.delete-image').on('click', function (e) {
        //     e.preventDefault();
        //     let imageWrapper = $(this).closest('.image-wrapper');
        //     $.ajaxSetup({
        //         headers: {
        //             'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        //         }
        //     });
        //
        //     $.ajax({
        //         url:'/delete-event-image',
        //         type:'POST',
        //         data: {id: $('#id').val()},
        //         success: function(response) {
        //             if (response.result === true) {
        //                 imageWrapper.hide();
        //                 $('body').notification({
        //                     type: 'info',
        //                     title: 'Erfolgreich',
        //                     message: 'Die Datei wurde erfolgreich gelöscht',
        //                     autoClose: 4000
        //                 });
        //             } else {
        //                 $('body').notification({
        //                     type: 'error',
        //                     title: 'Upload',
        //                     message: 'Die Datei konnte leider nicht gelöscht werden',
        //                     autoClose: 4000
        //                 });
        //             }
        //         },
        //     });
        // });


        $('body').on('click', '#submitForm', function(e) {
            e.preventDefault();

            let fd = new FormData();

            fd.append('id', $('#id').val())
            fd.append('event_group_id', $('#event_group_id').val())
            fd.append('event_name', $('#event_name').val())
            fd.append('event_subtitle', $('#event_subtitle').val())
            fd.append('event_faculty', $('#event_faculty').val())
            fd.append('event_candidates_limit', $('#event_candidates_limit').val())
            fd.append('event_start_date', $('#event_start_date').val())
            fd.append('event_deadline', $('#event_deadline').val())
            // fd.append('event_notice', CKEDITOR.instances.event_notice.getData())
            // fd.append('event_participation_modalities', CKEDITOR.instances.event_participation_modalities.getData())
            // fd.append('event_primary_color', $('#event_primary_color').val())
            // fd.append('event_secondary_color', $('#event_secondary_color').val())
            // fd.append('event_email_subject', $('#event_email_subject').val())
            // fd.append('event_email_reply_to', $('#event_email_reply_to').val())
            // fd.append('event_email_text', CKEDITOR.instances.event_email_text.getData())
            // fd.append('event_email_signature', CKEDITOR.instances.event_email_signature.getData())
            fd.append('event_publish', $('#event_publish').val())

            // let image = $('#event_image')[0].files[0];
            //
            // if (image !== undefined) {
            //     fd.append('event_image', image)
            // } else {
            //     fd.append('event_image', $('#event_image').val());
            //     fd.append('event_image_path', $('#event_image_path').val());
            // }

            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            $.ajax({
                url:'/event-save',
                type:'POST',
                data: fd,
                contentType: false,
                processData: false,
                success: function(response) {
                    window.location.reload();
                },
            });
        });

    }
});
